import dragula from "dragula";

let url = '/user/isAdmin';
let isAdmin = false;

$.ajax({
    type: "GET",
    url: url,
}).then(function (data) {
    isAdmin = data;
});

let draking = dragula({
    isContainer: function (el) {
        return el.classList.contains('draggable-container');
    },

    moves: function (el, source, handle, sibling) {
        if (el.firstElementChild.classList.contains('disable-dragging'))
            return false;
        return isAdmin;
    },

    accepts: function (el, target, source, sibling) {
        let targetDate = target.id;
        let today = new Date();

        if (targetDate < today.toISOString().split('T')[0])
            return false;
        return isAdmin;
    }
});

draking.on('drop', function (el, target) {
    Livewire.dispatch('changeDateOnItem', {
        appointment: el.id,
        date: target.id
    })
})
